import { REACT_APP_FALLBACK_LOCALE, REACT_APP_NODE_ENV } from '../config';

export * from './i18n-constants';
export * from './msal-constants';
export * from './route-constants';
export * from './route-constants';

export const ErrorType = {
  consentError: 'consent.error',
  papiError: 'papi.general.error',
};

export const ConsentError = {
  serverError: 'server_error',
  accessDenied: 'access_denied',
  unknownClient: 'unknown_client',
  noVehicles: 'no_vehicles',
  invalidAccount: 'invalid_account',
  invalidInput: 'invalid_input',
  missingQueryParams: 'query_params_missing',
};

export const ErrorParams = {
  code: 'code',
  desc: 'desc',
  msg: 'msg',
  status: 'status',
  subcode: 'subcode',
  subDesc: 'subDesc',
  addInfo: 'addInfo',
  moreInfo: 'moreInfo',
};

export const QueryParams = {
  clientId: 'client_id',
  scope: 'scope',
  redirectUri: 'redirect_uri',
  responseType: 'response_type',
  state: 'state',
  locale: 'locale',
  channel: 'channel',
};

export const TokenParams = {
  idToken: 'msal.idtoken',
  profileId: 'profile_id',
};

export const ReasonCode = {
  foundVehicles: 'FOUND_VEHICLES',
  foundOnStarHome: 'FOUND_ONSTAR_HOME',
};

export const ConsentAction = {
  GRANT: 'GRANT',
  REVOKE: 'REVOKE',
};

export const onStarHomeScopeService = {
  scope: 'ONSTAR_HOME',
  services: [],
};

export const Spinner = {
  invisibleClass: 'invisible',
};

export const fallBackLocale = REACT_APP_FALLBACK_LOCALE;

export const isDevelopment = REACT_APP_NODE_ENV === 'local';
